import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../contexts/userProvider";
import MarcaModelo from "./Types/marcaModelo";
import Grupos from "./Types/grupos";
import Cadastro from "./Types/cadastro";
import Consulta from "./Types/consulta";
import Historico from "./Types/historico";
import Estoque from "./Types/estoque";
import TabNavigation from "../General/TabNavigation";

const Patrimonio = () => {
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("Consulta");

  useEffect(() => {
    if (!user) {
      window.location.href = "/login";
    }
  }, [user]);

  const tabs = [
    {
      key: "Consulta",
      label: "Consulta",
      icon: "folder",
      content: <Consulta />
    },
    {
      key: "Cadastro",
      label: "Cadastro",
      icon: "config",
      content: <Cadastro />
    },
    {
      key: "Estoque",
      label: "Estoque",
      icon: "database",
      content: <Estoque />
    },
    {
      key: "Histórico Patrimônio",
      label: "Histórico Patrimônio",
      icon: "chart",
      content: <Historico />
    }
  ];

  // Adiciona abas condicionais baseadas no nível do usuário
  if (user?.nivel === '3') {
    tabs.push(
      {
        key: "Marca/Modelo",
        label: "Marca/Modelo",
        icon: "config",
        content: <MarcaModelo />
      },
      {
        key: "Grupos",
        label: "Grupos",
        icon: "layer",
        content: <Grupos />
      }
    );
  }

  return (
    <div className="w-full min-h-full">
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="default"
      />
    </div>
  );
};

export default Patrimonio;
